// Single safe helper for all listing images with fallback chain
export function getListingImage(listing: {
  image_url?: string | null;
  images?: (string | null)[] | null;
  category_slug?: string | null;
  updated_at?: string | null;
}) {
  const src =
    listing?.image_url ||
    (listing?.images && listing.images[0]) ||
    (listing?.category_slug ? `/images/categories/${listing.category_slug}.jpg` : '/images/categories/default.jpg');

  const v = listing?.updated_at ? new Date(listing.updated_at).getTime() : Date.now();
  return `${src}?v=${v}`;
}

